import { useLocation, useNavigate } from "react-router-dom";
import InfoRow from "../../components/InfoRow";
import EnrollmentLetterField from "../../components/EnrollmentLetterField";
import TopAchieverField from "../../components/TopAchieverField";
import UNAUTHORIZED from "../UNAUTHORIZED";
import ActionButtonsPrint from "./ActionButtonsPrint";
import ActionButtonsValid from "./ActionButtonsValid";
import jsPDF from "jspdf";
import logo1 from "./logo1.png";
import logo from "./logo.png";
import Qr from "./Qr.png";
import html2canvas from "html2canvas";

// Categories whose report text omits the enrolment-letter reference. The two
// UAE categories follow their Outside counterparts: foreignA_UAE is treated
// the same as outsideA, foreignB_UAE the same as outside.
const NO_ENROLMENT_LETTER_CATS = new Set([
  "outside",
  "outsideA",
  "foreign",
  "foreignA",
  "foreignA_UAE",
  "foreignB_UAE",
]);
export default function StudentPrint() {
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;
  const location = useLocation();
  const navigate = useNavigate();
  const studentType = useLocation().pathname.split("/")[3];
  const element = location.state;
  console.log("Student Data Received in Print Component:", element);

  const generatePDF = () => {
    const doc = new jsPDF();
    let hasLineBeforeScience = false; // Track if line is drawn before Science

    // Add this helper function at the top of your file (or near your other helpers)
    function formatDateLong(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr; // fallback if invalid
      const day = date.getDate();
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();
      return `${day} - ${month} - ${year}`;
    }

    function formatDateEnrolment(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr; // fallback if invalid
      const dayE = date.getDate();
      const monthE = date.toLocaleString("en-US", { month: "long" });
      const yearE = date.getFullYear();
      return ` ${monthE} ${dayE} , ${yearE}`;
    }
    let y = 20; // starting vertical position

    // Generated Date
    //doc.setFontSize(8);
    //doc.setFont("helvetica");
    //doc.text(`Generated on: ${formattedDate}`, 93, 275);

    // Header
    doc.setFontSize(10);
    doc.setFont("Times-Roman");
    doc.text("To: The Arab Republic of Egypt", 15, y); y += 4;
    doc.text("Ministry of Education", 15, y); y += 4;
    doc.text("New Capital", 15, y); y += 4;
    doc.text("Cairo", 15, y); y += 4;
    doc.text("Egypt", 15, y); y += 10;

    // Logo
    const imgWidth = 50;
    const imgHeight = 15;
    doc.addImage(logo1, "PNG", 140, 30, imgWidth, imgHeight);
    y += 15; // leave space after logo

    //Title
    doc.setFont("Times-Roman", "bold");
    doc.setFontSize(13);
    doc.text(`SCORE VERIFICATION REPORT`, 100, y, { align: "center" });
    y += 10;
    doc.setFont("Times-Roman", "normal");

    // Greeting
    doc.setFontSize(12);
    doc.text(`Dear Sir/Madam`, 15, y); y += 8;

    // Body Intro
    doc.setFontSize(12);
    doc.text(
      `We would like to confirm that we have done score verification and ID checks, and we do confirm that all the data in the report is correct and authenticated.`,
      15,
      y,
      { maxWidth: 180 }
    );
    y += 10;


    // Student Info
    doc.setFontSize(12);
    doc.setFont("Times-Roman", "bold");
    const fullName = element.full_name.toUpperCase();
    doc.text(`(Full Name): ${fullName}`, 15, y); y += 8;
    doc.text(`(NATIONAL ID / Passport NO): ${element.id}`, 15, y); y += 8;
    doc.setFont("Times-Roman", "normal");
    doc.setFontSize(12);
    doc.text(
      `The School Name: ${element.school_name}. ${NO_ENROLMENT_LETTER_CATS.has(element.category) ? '' : `Reference to the enrollment letter dated ${formatDateEnrolment(element.enrolment_date)}:`} The student is registered at ${element.school_name} in ${element.school_city}, ${element.school_country}, and  ${element.grade_status}.\n`,
      15,
      y,
      { maxWidth: 180 }
    );
    y += 23;

    if (element.act1_id && element.act1_id !== 'null') {
      doc.text(`ACT ID: ${element.act1_id}`, 15, y); y += 5;
    }
    if (element.act2_id && element.act2_id !== 'null') {
      doc.text(`AIST ID : ${element.act2_id}`, 15, y); y += 8;
    }
    // Exam Info
    let examName = element.exam_name
      .replace("ACT1 ", "")
      .replace("Certificate", "")
      .replace("Score", "");




    // ACT Composite Score (move above Subject Scores)
    if (Array.isArray(element.act1_scores) && element.act1_scores.length > 0) {
      // Group by trial_no
      const grouped = new Map();
      element.act1_scores.forEach((item) => {
        const tno = item.trial_no;
        if (!grouped.has(tno)) {
          grouped.set(tno, {
            trial_no: tno,
            trial_id: item.trial_id,
            trial_date: item.trial_date,
            total_score: item.total_score,
            subjects: []
          });
        }
        grouped.get(tno).subjects.push({
          subject_name: item.subject_name,
          subject_score: item.subject_score,
          subject_date: item.subject_date
        });
      });

      // Sort subjects within each trial by the correct order for PDF: English, Reading, Math, Science
      const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];
      grouped.forEach((trial) => {
        trial.subjects.sort((a, b) => {
          const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
          const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
          return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
        });
      });

      const trials = Array.from(grouped.values());
      let selectedTrial = null;
      if (element.exam_name === "ACT1 One Trial Certificate") {
        selectedTrial = trials.find(t => t.trial_no === 1) || trials[0];
      } else if (
        element.exam_name === "ACT1 Super Score Certificate" ||
        element.exam_name === "ACT1 Matching Certificate" ||
        element.exam_name === "ACT 1 Matching Certificate"
      ) {
        selectedTrial = trials.reduce((max, t) => (t.trial_no > max.trial_no ? t : max), trials[0]);
      } else {
        selectedTrial = trials[0];
      }
      // Show date as month/year for 'ACT1 One Trial Certificate', hide for 'ACT1 Super Score Certificate', else show full date
      if (element.exam_name === "ACT1 Super Score Certificate") {
        doc.text(
          `ACT  ${examName} Score : ${selectedTrial.total_score}/36 .`,
          15,
          y,
          { maxWidth: 180 }
        );
      } else if (element.exam_name === "ACT1 One Trial Certificate") {
        // Format trial_date as 'Month Year'
        let formattedTrialDate = '';
        if (selectedTrial.trial_date) {
          const d = new Date(selectedTrial.trial_date);
          const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
          formattedTrialDate = `${months[d.getMonth()]} ${d.getFullYear()}`;
        }
        doc.text(
          `ACT Score : ${selectedTrial.total_score}/36 .`,
          15,
          y,
          { maxWidth: 180 }
        );
      } else {
        doc.text(
          `ACT  ${examName} : ${selectedTrial.total_score}/36 .`,
          15,
          y,
          { maxWidth: 180 }
        );
      }
      y += 8;
      // Print each subject and its score for the selected trial
      if (Array.isArray(selectedTrial.subjects) && selectedTrial.subjects.length > 0) {
        selectedTrial.subjects.forEach((subject) => {
          // Add line before Science subject if date is after 01-09-2025
          if (subject.subject_name && subject.subject_name.toLowerCase().includes('science') &&
            (element.exam_name === "ACT1 One Trial Certificate" || element.exam_name === "ACT1 Super Score Certificate")) {

            // Check if science date is September 1, 2025 or later
            let scienceDate = null;
            if (subject.subject_date) {
              scienceDate = new Date(subject.subject_date);
            }

            const cutoffDate = new Date('2025-09-01');
            if (scienceDate && scienceDate >= cutoffDate) {
              // Add a horizontal line before Science subject
              doc.line(15, y - 5, 100, y - 5);
              // Half width line from x=15 to x=105, moved up closer to Math
              hasLineBeforeScience = true; // Set flag when line is drawn
            }
          }

          // Format subject_date as 'Month Year' if available
          let formattedDate = '';
          if (subject.subject_date) {
            const d = new Date(subject.subject_date);
            const months = [
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'
            ];
            formattedDate = `${months[d.getMonth()]} ${d.getFullYear()}`;
          } else if (selectedTrial.trial_date) {
            const d = new Date(selectedTrial.trial_date);
            const months = [
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'
            ];
            formattedDate = `${months[d.getMonth()]} ${d.getFullYear()}`;
          }
          doc.text(
            ` ${subject.subject_name} :  ${subject.subject_score}/36 dated ${formattedDate} . `,
            15,
            y,
            { maxWidth: 180 }
          );
          y += 7;
        });
      }
      y += 2;
    } else {
      doc.text(
        `ACT ${examName}  Score : ${element.act1_score1}/36 dated ${element.act1_try_date1}.`,
        15,
        y,
        { maxWidth: 180 }
      );
      y += 15;
    }

    function formatDateLong2(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr; // fallback if invalid
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();
      return `${month} , ${year}`;
    }

    // Subject Scores (now after ACT Composite Score)
    if (element.subject1 && element.act2_score1) {
      doc.text(
        `AIST Score: \n \n${element.subject1} : ${element.act2_score1}/36 dated ${formatDateLong2(element.act2_try_date1)}.`,
        15,
        y,
        { maxWidth: 180 }
      );
      y += 11;
    }
    if (element.subject2 && element.act2_score2) {
      doc.text(
        `\n${element.subject2} : ${element.act2_score2}/36 dated ${formatDateLong2(element.act2_try_date2)}.`,
        15,
        y,
        { maxWidth: 180 }
      );
      y += 8;
    }
    if (element.subject3 && element.act2_score3) {
      doc.text(
        `\n${element.subject3} : ${element.act2_score3}/36 dated ${formatDateLong2(element.act2_try_date3)}.`,
        15,
        y,
        { maxWidth: 180 }
      );
      y += 8;
    }

    // Signature
    doc.text(`\nYours truly,`, 15, y); y += 8;
    doc.setFont("Times-Roman", "bold");
    doc.setFontSize(12);
    doc.text(`\nDR.Hussam Ezz Eldin`, 15, y); y += 10;

    // Footer Logo
    doc.setFontSize(14);
    doc.addImage(logo, "PNG", 15, y, imgWidth, imgHeight);
    y += 25;

    // QR Verification
    doc.setFont("Times-Roman", "normal");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 255);

    // Move QR upward in both cases - more upward if line was drawn before Science
    y += hasLineBeforeScience ? -15 : -10;

    // Draw QR just after the footer logo
    const qrX = 30;
    const qrSize = 36;
    doc.addImage(Qr, "PNG", qrX, y, qrSize, qrSize);

    // Position text below the QR
    y += qrSize + 8; // push Y to just below the QR, with 8pt padding
    doc.text(`To verify the certificate, you can scan the QR code`, 15, y);
    doc.text(`Scan QR Code`, 150, y);
    // Save PDF
    doc.save(`ACT-1+2-${element.id}.pdf`);

  };

  const generate_Arabic_PDF = () => {
    const doc = new jsPDF({
      unit: 'mm',
      format: 'a4'  // Custom size (A4 landscape dimensions)
    });
    // Border settings
    doc.setDrawColor(0, 0, 0); // Black border color
    doc.setLineWidth(1);       // Border thickness (mm)

    // Draw the rectangle border
    doc.rect(5, 5, 200, 287); // x, y, width, height

    let arabicText = `
      <div>
        <h1>الطالب عائد من الخارج وتم اختباره بدولة <strong>${element.center_test_country}</strong> </h1>
      `;
    if (element.subject1 && element.act2_score1) {
      arabicText += `
      <h1>وحاصل على <strong>${element.act2_score1}</strong>/36 درجة في مادة <strong>${element.subject1}</strong></h1>
      `;
    }
    if (element.subject2 && element.act2_score2) {
      arabicText += `
      <h1>وحاصل على <strong>${element.act2_score2}</strong>/36 درجة في مادة <strong>${element.subject2}</strong></h1>
      `;
    }
    if (element.subject3 && element.act2_score3) {
      arabicText += `
      <h1>وحاصل على <strong>${element.act2_score3}</strong>/36 درجة في مادة <strong>${element.subject3}</strong></h1>
      `;
    }
    arabicText += `
      <p>وذلك في ضوء مراجعة واعتماد الشركة المسئولة  عن اختبارات الــ ACT داخل جمهورية مصر العربية،</p>
      <p>المفوضة من الشركة الأم بالولايات المتحدة الأمريكية، وعلى مسؤليتها  وجميع المستندات العائدة بها من الخارج تتم بمعرفة مكتب التنسيق بوزارة التعليم العالي.</p>
        <p style="font-size: 35px; margin-top: 5%;">
        <span style="display: inline-block; margin-left: 350px;">اللجنة</span>
        <span style="display: inline-block;">مدير الاداره</span>
        </p>
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20%; margin-right: 50%; font-size: 30px;">
      <p><strong>يعتمد</strong></p>
      </br>
      <p><strong>مدير عام الادارة العامة للتعليم الخاص والدولى</strong></p>
            <br></br>
      <p><strong>(  أ/ هشام جعفر  )</strong></p>
    </div>
     <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20%; font-size: 30px;">
      <p><strong>رئيس الادارة المركزية للتعليم بمصروفات</strong></p>
      <br></br>
      <p><strong>(  أ/ ﷴ عطية  )</strong></p>
    </div>
    </div>
    `;


    const arabicElement = document.createElement("div");
    arabicElement.style.fontSize = "36px";
    arabicElement.style.fontFamily = "Arial, sans-serif";
    arabicElement.style.direction = "rtl";
    arabicElement.style.padding = "20px";
    arabicElement.style.margin = "20px";
    arabicElement.innerHTML = arabicText;
    document.body.appendChild(arabicElement);

    html2canvas(arabicElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgProps = doc.getImageProperties(imgData);

      const pdfWidth = doc.internal.pageSize.getWidth();

      // Scale factor: 90% of page width
      const scaleFactor = 0.9;
      const imgWidth = pdfWidth * scaleFactor;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      // Center the image horizontally
      const x = (pdfWidth - imgWidth) / 2;
      // Example: position 40mm from top
      const y = 40;

      doc.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
      // Save the PDF
      doc.save(`MOE-Send-${element.id}.pdf`);
      // Clean up
      document.body.removeChild(arabicElement);
    });
  };
  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div className="flex justify-center">
          <div className="lg:w-3/5 md:w-3/4 w-full border shadow flex flex-col p-3 rounded-lg bg-gray-50">
            <div className="flex items-center justify-between">
              <span className="text-xl">Student Information</span>
              <span
                className="cursor-pointer rounded-full w-9 h-9 bg-red-400 text-white flex items-center justify-center active:scale-90 hover:bg-red-500"
                onClick={() => navigate(-1)}
              >
                X
              </span>
            </div>
            <div className="flex flex-col m-3">
              <InfoRow data={element.id} label={"ID"} about="id" />
              <InfoRow
                data={element.full_name}
                label={"Full Name"}
                about="full_name"
              />
              <InfoRow data={element.email} label={"Email"} about="email" />
              <InfoRow
                data={element.address}
                label={"Address"}
                about="address"
              />
              <InfoRow
                data={element.postal_code}
                label={"Postal Code"}
                about="postal_code"
              />
              <InfoRow
                data={element.date_of_birth}
                label={"Data of Birth"}
                about="data_of_birth"
              />
              <InfoRow data={element.gender} label={"Gender"} about="gender" />
              <InfoRow data={element.phone} label={"Phone"} about="phone" />
              <InfoRow
                data={element.school_name}
                label={"School Name"}
                about="school_name"
              />
              <InfoRow
                data={element.school_city}
                label={"School City"}
                about="school_city"
              />
              <InfoRow
                data={element.school_country}
                label={"School Country"}
                about="school_country"
              />
              <InfoRow
                data={element.test_center_name}
                label={"Test Center Name"}
                about="test_center_name"
              />
              <EnrollmentLetterField
                studentId={element.id}
                initialValue={element.enrollment_letter_received}
                fileName={element.enrollment_letter_file}
                assignedUser={element.enrollment_letter_assigned_user}
              />
              <TopAchieverField
                studentId={element.id}
                initialValue={element.top_achievers}
                initialFee={element.top_achievers_fee}
              />

              <div className="p-2 border rounded mt-1 bg-blue-50">
                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_id}
                  label={"ACT 1 ID"}
                  about="act1_id"
                />
                <InfoRow
                  data={element.exam_name}
                  label={"Exam Name"}
                  about="exam_name"
                />

                {/* --- Dynamic Scores & Dates Section --- */}
                {/* 
        We now loop through the 'scores' array.
        The backend method returns this as an array of objects.
        Each object represents one trial.
    */}
                {/* Render ACT1 scores grouped by trial_no from flat array */}
                {Array.isArray(element.act1_scores) && element.act1_scores.length > 0 ? (
                  (() => {
                    // Define the correct subject order
                    const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];

                    // Group by trial_no robustly (avoid duplicate trials)
                    const grouped = new Map();
                    element.act1_scores.forEach((item) => {
                      const tno = item.trial_no;
                      if (!grouped.has(tno)) {
                        grouped.set(tno, {
                          trial_no: tno,
                          trial_id: item.trial_id,
                          trial_date: item.trial_date,
                          total_score: item.total_score,
                          subjects: []
                        });
                      }
                      grouped.get(tno).subjects.push({
                        subject_name: item.subject_name,
                        subject_score: item.subject_score,
                        subject_date: item.subject_date
                      });
                    });

                    // Sort subjects within each trial by the correct order
                    grouped.forEach((trial) => {
                      trial.subjects.sort((a, b) => {
                        const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
                        const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
                        // If subject not found in order array, put it at the end
                        return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
                      });
                    });

                    // Render each trial only once
                    return Array.from(grouped.values()).map((scoreTrial, index) => (
                      <div key={scoreTrial.trial_no || index} className="p-2 my-2 border rounded bg-white shadow-sm">
                        <h4 className="font-bold text-md mb-2 text-blue-800 border-b pb-1">
                          Trial {scoreTrial.trial_no}
                        </h4>
                        <InfoRow
                          data={scoreTrial.total_score}
                          label={"Total Score"}
                          about={`act1_total_score_${scoreTrial.trial_no}`}
                        />
                        <InfoRow
                          data={scoreTrial.trial_date}
                          label={"Trial Date"}
                          about={`act1_trial_date_${scoreTrial.trial_no}`}
                        />
                        {/* If there are subject scores, display them */}
                        {Array.isArray(scoreTrial.subjects) && scoreTrial.subjects.length > 0 && (
                          <div className="mt-2 pl-4 border-l-2 border-blue-200">
                            <h5 className="font-semibold text-sm text-gray-600 mb-1">Subject Details:</h5>
                            {scoreTrial.subjects.map((subject, subIndex) => (
                              <div key={subIndex} className="flex flex-col mb-1">
                                <InfoRow
                                  data={subject.subject_score}
                                  label={subject.subject_name}
                                  about={`act1_subject_${String(subject.subject_name).toLowerCase()}_${scoreTrial.trial_no}`}
                                />
                                {subject.subject_date && (
                                  <InfoRow
                                    data={subject.subject_date}
                                    label={"Subject Date"}
                                    about={`act1_subject_date_${String(subject.subject_name).toLowerCase()}_${scoreTrial.trial_no}`}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ));
                  })()
                ) : (
                  <p className="p-2 text-gray-500">No trial scores found for ACT 1.</p>
                )}

                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_copy_number}
                  label={"Copies Number"}
                  about="act1_copy_number"
                />
                <InfoRow
                  data={element.act1_moe_copy}
                  label={"MOE Copies Number"}
                  about="act1_moe_copy"
                />
              </div>
              {element.act2 && (
                <div className="p-2 border rounded mt-1 bg-green-50">
                  <InfoRow
                    data={element.act2_id}
                    label={"ACT 2 ID"}
                    about="act2_id"
                  />
                  <InfoRow
                    data={element.act2_score1}
                    label={"Score 1"}
                    about="act2_score1"
                  />
                  <InfoRow
                    data={element.act2_score2}
                    label={"Score 2"}
                    about="act2_score2"
                  />
                  <InfoRow
                    data={element.act2_score3}
                    label={"Score 3"}
                    about="act2_score3"
                  />
                  <InfoRow
                    data={element.act2_try_date1}
                    label={"Trial Date 1"}
                    about="act2_try_date1"
                  />
                  <InfoRow
                    data={element.act2_try_date2}
                    label={"Trial Date 2"}
                    about="act2_try_date2"
                  />
                  <InfoRow
                    data={element.act2_try_date3}
                    label={"Trial Date 3"}
                    about="act2_try_date3"
                  />
                  <InfoRow
                    data={element.subject1}
                    label={"Subject 1"}
                    about="subject1"
                  />
                  <InfoRow
                    data={element.subject2}
                    label={"Subject 2"}
                    about="subject2"
                  />
                  <InfoRow
                    data={element.subject3}
                    label={"Subject 3"}
                    about="subject3"
                  />
                  <InfoRow
                    data={element.act2_copy_number}
                    label={"Copies Number"}
                    about="act2_copy_number"
                  />
                  <InfoRow
                    data={element.act2_moe_copy}
                    label={"MOE Copies Number"}
                    about="act2_moe_copy"
                  />
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              {studentType === "new" ? (
                <>
                  <div className="flex space-x-4 mb-4">
                    <button
                      onClick={generatePDF}
                      className="px-4 py-2 border border-blue-600 text-black-600 bg-transparent hover:bg-black hover:text-white rounded transition duration-300"
                    >
                      Download Combined PDF
                    </button>

                    {element.act2 && (
                      <button
                        onClick={generate_Arabic_PDF}
                        className="px-4 py-2 border border-gray-600 text-white bg-blue-500 hover:bg-gray-600 hover:text-black rounded transition duration-300"
                      >
                        Generate Moe Sheet
                      </button>
                    )}
                  </div>
                  <ActionButtonsPrint />
                </>
              ) : (
                <>
                  {studentType === "print_validation" ? (
                    <ActionButtonsValid />
                  ) : null}
                </>
              )}
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
